import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { updatePassword } from '../../actions/authentication/authCreators';
import { Grid, Row, Col } from 'react-bootstrap';
import Banner from '../../components/Banner';
import PasswordForm from './PasswordForm';

class UpdatePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: undefined,
      isArchiving: false,
      isSaving: false,
      errorMsg: undefined,
      showVerification: false,
      isSending: false,
      isVerifying: false,
      user: {}
    };
    this.timeoutId = undefined;
  }

  onSubmit = values => {
    this.setState({ message: undefined });
    this.props.updatePassword(values).then(
      success =>
        this.setState({
          message: 'Password successfully updated.',
          messageType: 'success'
        }),
      error =>
        this.setState({ message: error.data.message, messageType: 'danger' })
    );
  };

  render() {
    return (
      <div className="App" aria-live="polite">
        <Banner title="My Account" image="mailbox" />
        <Grid>
          <Row>
            <Col sm={2} md={2} mdOffset={1} lg={2} lgOffset={1}>
              <Link to="/account" className="back-link">
                &#11104; Back to Account
              </Link>
            </Col>
            <Col sm={8} md={8} lg={6}>
              <br />
              <br />

              <PasswordForm
                onSubmit={this.onSubmit}
                initialValues={{}}
                isArchiving={this.state.isArchiving}
                message={this.state.message}
                messageType={this.state.messageType}
                isSaving={this.state.isSaving}
                enableReinitialize
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updatePassword
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(UpdatePassword);



// WEBPACK FOOTER //
// ./src/containers/account/UpdatePassword.js